import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/MLXC/countryGovern/returnVisit';
import { fetchList as fetchCustomerList } from '@/api/PMS/baseInformation/customer';
import { fetchDeptTree } from '@/api/system/dept/dept';
import { fetchRoleDeptUser, fetchToushu } from '@/api/system/role/role';
export default {
  props: {
    showDialog: Boolean,
    isDetail: Boolean,
    flowNum: String,
    complainantsId: {
      type: Number,
      default: -1
    },
    keyValue: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      rules: {
        feebackUserName: [{
          required: true,
          message: '请输入联系人',
          trigger: 'blur'
        }, {
          min: 2,
          max: 50,
          message: '请输入2 到 50 个字符',
          trigger: 'change'
        }],
        feebackUserMobile: [{
          required: true,
          message: '请输入联系人电话',
          trigger: 'blur'
        }, {
          min: 11,
          max: 11,
          message: '请输入11位手机号',
          trigger: 'change'
        }],
        userId: [{
          required: true,
          message: '请选择处理人',
          trigger: 'change'
        }],
        deptId: [{
          required: true,
          message: '请选择处理部门',
          trigger: 'change'
        }],
        feebackRemark: [{
          required: true,
          message: '请输入回访意见',
          trigger: 'blur'
        }, {
          max: 200,
          message: '最多输入200个字符',
          trigger: 'change'
        }],
        hostAdress: [{
          max: 200,
          message: '最多输入200个字符',
          trigger: 'change'
        }],
        feebackRating: [{
          required: true,
          message: '请选择满意类型',
          trigger: 'change'
        }]
      },
      propstree: {
        label: 'deptName',
        value: 'deptId',
        children: 'childDept'
      },
      childData: {
        userId: ''
      },
      deptOptions: [],
      deptId: null,
      customerOption: [],
      satisfiedOption: [{
        name: '非常满意',
        value: 1
      }, {
        name: '满意',
        value: 2
      }, {
        name: '不满意',
        value: 3
      }, {
        name: '非常不满意',
        value: 4
      }]
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init(); // this.getCustomerOption()

    this.loadDeptTree();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });
      console.log(this.keyValue);

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
        });
      } else {
        this.childData = {
          userId: ''
        };
      }
    },
    getCustomerOption: function getCustomerOption(data) {
      var _this2 = this;

      console.log(this.childData.userId, '1111111111');
      this.deptId = data[data.length - 1];
      console.log(this.deptId, 'dadadaffffff');
      fetchToushu({
        deptId: this.deptId,
        userStatus: 0
      }).then(function (res) {
        _this2.customerOption = res.data.data;
      });
      this.childData.userId = '';
    },
    loadDeptTree: function loadDeptTree() {
      var _this3 = this;

      var treeQuery = {};
      fetchDeptTree(treeQuery).then(function (response) {
        _this3.deptOptions = response.data.data;
      });
    },
    handCreate: function handCreate() {
      var _this4 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this4.childData.complaintId = _this4.complainantsId;

          if (_this4.isDetail) {
            fetchUpdate(_this4.childData).then(function () {
              _this4.$emit('handCancle', true);

              _this4.Alert({
                alertType: 'update'
              });
            });
          } else {
            fetchCreate(_this4.childData).then(function () {
              _this4.$emit('handCancle', true);

              _this4.Alert({
                alertType: 'add'
              });
            });
          }
        } else {
          _this4.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};